import React, {Component} from 'react';
import { connect }          from 'react-redux';
import './index.scss';


//components
import {deleteToken} from "../../../../redux/actions";

//assets
import desktop_exit from 'assets/icons/login-x-icon.svg';
import {getMediaPath} from "../../../../app/functions";

class DeleteCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sendAgainCount: 0,
        };
        this.animateOut  = this.animateOut.bind(this);
        this.animateIn   = this.animateIn.bind(this);
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();

        if(this.props.isAcquired){
            this.setState({step: 2});
        }
    }
    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }
    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleBtnClick = () =>{
        this.props.action();
        this.animateOut();
    };

    render() {

        const text = this.props.transaction;
        const isDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';
        const {zipCode = false} = this.props;

        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper delete-card " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <div className="popup_content">
                        <button className="x_close_icon"
                                onClick={() => this.animateOut()}
                                aria-label="סגור"><img src={getMediaPath(desktop_exit)} alt='/'/>
                        </button>

                        <span className='title'>{this.props.title}</span>
                        <div className='card-wrap'>
                            {!isDesktop && !zipCode && <span>מאסטרקארד</span>}
                            <span>{ this.props.credit_number }</span>
                        </div>
                        {zipCode && <span className='card-wrap'>{zipCode}</span>}
                        <span className='name'>{this.props.holderName}</span>
                        <button className='remove-btn' onClick={this.handleBtnClick}>{this.props.deleteText}</button>
                        <span className='cancel-span' onClick={() => this.animateOut()}>{text['delete_card_cancel']}</span>
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.PopTrans,
        transaction: store.config.Translations,
        userDate: store.config.UserData,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        deleteToken: (payload) => dispatch(deleteToken(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(DeleteCard);